import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    slotId: Number,
    loadingText: { type: String, default: "Loading..." }
  }

  showExplanation(event) {
    event.preventDefault()
    event.stopPropagation()

    const slotId = this.slotIdValue || event.params.slotId
    if (!slotId) return

    // Find or create the modal
    let modal = document.getElementById("unfilled_explanation_modal")
    const isNewModal = !modal
    if (isNewModal) {
      modal = this.createModal()
      document.body.appendChild(modal)
    }

    // Reset frame content to loading state and load new content
    const frame = modal.querySelector("#unfilled_explanation_frame")
    if (frame) {
      frame.innerHTML = `
        <div class="p-6 text-center">
          <i class="fas fa-spinner fa-spin text-gray-400 text-2xl"></i>
          <p class="mt-2 text-gray-500">${this.loadingTextValue}</p>
        </div>
      `
      frame.removeAttribute("src")
      frame.removeAttribute("complete")
      frame.src = `/admin/shift_slots/${slotId}/unfilled_explanation`
    }

    // The modal controller re-hides an open modal when it connects; Stimulus connects it in the
    // mutation-observer microtask, so reveal in a later microtask (an animation frame can lag seconds under load)
    queueMicrotask(() => modal.classList.remove("hidden"))
  }

  createModal() {
    const modal = document.createElement("div")
    modal.id = "unfilled_explanation_modal"
    modal.className = "fixed inset-0 z-50 items-center justify-center p-4 hidden"
    modal.dataset.controller = "modal"
    modal.innerHTML = `
      <div class="fixed inset-0 bg-black/50" data-action="click->modal#close"></div>
      <div class="relative bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <turbo-frame id="unfilled_explanation_frame">
          <div class="p-6 text-center">
            <i class="fas fa-spinner fa-spin text-gray-400 text-2xl"></i>
            <p class="mt-2 text-gray-500">${this.loadingTextValue}</p>
          </div>
        </turbo-frame>
      </div>
    `

    return modal
  }
}
